import UranusEducation from '../../components/newuranus/UranusEducation';

const Uranus = () => {
    return <UranusEducation/>;
};

export default Uranus;
